import React, { useState, useEffect } from "react"
import InlineGenericEditComponent from "./InlineGenericEditComponent"
import DateDisplayComponent from "./DateDisplayComponent"
import InlineDatePickerComponent from "./InlineDatePickerComponent"
import { getAction } from "../../../state/actionlog/actionLogSelector"
import { connect, ConnectedProps } from "react-redux"

type OwnProps = {
    value: string,
    onSave: (a: string, b: string) => void,
    id: string
}

const InlineDateEditComponent = (props: Props) => {
    const [currentDate, setCurrentDate] = useState<string>(props.value)
    const [date, setDate] = useState(props.value)

    useEffect(() => setCurrentDate(props.value), [props.value])
    return (
        <InlineGenericEditComponent
            valueObject={
                <DateDisplayComponent
                    date={currentDate}
                />
            }
            inputObject={
                <InlineDatePickerComponent
                    date={date}
                    setDate={setDate}
                />
            }
            action={props.action}
            onSave={() => props.onSave(date, props.id)}
            popupStyle={{ minWidth: "350px" }}
        />
    )
}

const mapState = (state, props: OwnProps) => {
    const action = getAction(state, props.id)
    return { ...props, action: action}
}

const connector = connect(mapState, {})
type Props = ConnectedProps<typeof connector>
export default connector(InlineDateEditComponent)


// WEBPACK FOOTER //
// ./src/common/inline-edit/component/InlineDateEditComponent.tsx